import { render, staticRenderFns } from "./_news.vue?vue&type=template&id=5b332516"
import script from "./_news.vue?vue&type=script&lang=js"
export * from "./_news.vue?vue&type=script&lang=js"
import style0 from "./_news.vue?vue&type=style&index=0&id=5b332516&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderNewsPage: require('/home/apprentissage-montpellier/www/prod/AM-frontend/components/HeaderNewsPage.vue').default})
